import { render, staticRenderFns } from "./TemplateLoaderNewsSingle.vue?vue&type=template&id=1894cf84&scoped=true&"
import script from "./TemplateLoaderNewsSingle.vue?vue&type=script&lang=js&"
export * from "./TemplateLoaderNewsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894cf84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
